<template>
  <div class="outer-box re-enable-looped-automations">
    <h4>Re-enable Automations that are Loop Locked</h4>
    <div class="inner-box" style="text-align: left; width: 600px;">
      <label>Automation Type (collection)</label>
      <select
        class="hl_input--wrap"
        type="text"
        v-model="automationType"
      >
        <option v-for="doc in ['Campaign', 'Trigger', 'Workflow']" :key="doc" :value="doc">{{ doc }}</option>
      </select>
      <label class="mt-4">Automation ID</label>
      <input
        class="hl_input--wrap my-1"
        type="text"
        placeholder="Automation ID"
        v-model="automationId"
      />
      <button class="btn btn-primary mt-4" @click="submit">
        <moon-loader v-if="loading" :loading="loading" size="21px" color="#fafafa" />
        <span v-else>Unlock</span>
      </button>
    </div>
  </div>
</template>

<script>
import { SpmAppengineService } from '@/services';

export default {
  data() {
    return {
      automationId: '',
      loading: false,
      automationType: 'Trigger',
    };
  },
  methods: {
    async submit() {
      this.loading = true;
      const type = this.automationType.toLowerCase();
      try {
        await SpmAppengineService.reEnableLoopedDocument(this.automationId, type)
      } catch (err) {
        console.error(err);
        alert(`An error has ocurred: ${JSON.stringify(err.message ? err.message : err)}`);
      } finally {
        this.loading = false;
      }
    },
  }
}
</script>

<style>
.re-enable-looped-automations {
  min-width: 40vw;
}
</style>
